import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TutorielPrePage.scss';
import toolBox from '../assets/icons/tool-box.png';
import footsteps from '../assets/icons/footsteps.png';
import dataTutoEnglish from './dataTutoEnglish';

const TutoDetails = function TutoDetails() {
  const { slug } = useParams();
  const tutoriel = dataTutoEnglish.find((tuto) => tuto.slug === slug);
  const navigate = useNavigate();
  return (
    <div>
      <h1 className="toolTitle">Tools you&#39;ll need for this tutorial:</h1>

      <div className="blocTool">
        <div className="dataTuto">
          <h3>{tutoriel.nomTuto}</h3>
          <h4>{tutoriel.intro}</h4>
          <h5>Difficulty: {tutoriel.difficulty}</h5>
          <h5>Time: {tutoriel.time}</h5>
          <h6>Category: {tutoriel.category}</h6>
          <img
            src={footsteps}
            alt="Icon of manomano steps"
            className="footstep"
          />
          <h3>You can do it in {tutoriel.steps.length} steps</h3>{' '}
          <img src={toolBox} alt="Icon of tool box" className="toolbox" />
          <section className="materiau">
            {tutoriel.materiaux.map((materiau) => (
              <div className="nomTool" key={materiau.nom}>
                <a href={materiau.lien} target="_blank" rel="noreferrer">
                  <div>{materiau.nom}</div>
                </a>
                <img src={materiau.img} alt="Screen of the tool" />
              </div>
            ))}
          </section>
          <button
            type="submit"
            className="more"
            onClick={() => navigate(`/allamano/${tutoriel.slug}/1`)}
          >
            Get started
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutoDetails;
